export const SET_POSITIONS = 'SET_POSITIONS'
export const REFRESH_POSITIONS = 'REFRESH_POSITIONS'
export const ADD_POSITIONS = 'ADD_POSITIONS'
